// LivestreamViewerCamera.js
'use strict';
import { connect } from 'react-redux';

import LivestreamViewerCamera from '../component/LivestreamViewerCamera.jsx';

import getLiveStreamData from '../selector/getLiveStreamData.js';
import getGoalData from '../selector/getGoalData.js';
import {
  getHasLivestreamTopGift,
  getViewerCameraData,
} from '../selector/getLivestreamComputedData.js';
import {
  PREVIEW_TRIGGER,
  startViewerCameraPreview,
  invalidateViewerCameraPreview,
  publishViewerCamera,
  startViewerCamera,
  stopViewerCamera,
  setViewerCameraTrackEnabled,
  openViewerCameraMoreModal,
} from '../action/exclusiveViewerCameraActions.js';
import { LOCAL_TRACK_TYPE } from '../resource/agoraLocalTracks.js';
import { ExclusivePrivateStatus } from '../resource/liveStreamConstants.js';

const mapStateToProps = (state, { streamId }) => {
  const status = getLiveStreamData(
    state,
    [streamId, 'exclusivePrivate'],
    'status'
  );
  const currentGoalId = getLiveStreamData(
    state,
    [streamId, 'exclusivePrivate'],
    'currentId'
  );
  return {
    channelId: getLiveStreamData(state, [streamId], 'sessionId'),
    isPreviewReady: getViewerCameraData(state, streamId, 'isPreviewReady'),
    isPublishing: getViewerCameraData(state, streamId, 'isPublishing'),
    isAudioEnabled: getViewerCameraData(state, streamId, 'isAudioEnabled'),
    isVideoEnabled: getViewerCameraData(state, streamId, 'isVideoEnabled'),
    cameraSwitchVersion: getViewerCameraData(
      state,
      streamId,
      'cameraSwitchVersion'
    ),
    isInMainWindow: getViewerCameraData(state, streamId, 'isInMainWindow'),
    hasMediaAccessError: getViewerCameraData(
      state,
      streamId,
      'hasMediaAccessError'
    ),
    isPerforming: status === ExclusivePrivateStatus.PERFORMING,
    isPreparing: status === ExclusivePrivateStatus.PREPARING,
    performingStartUnix: getGoalData(state, [currentGoalId], 'nbf'),
    hasTopGift: getHasLivestreamTopGift(state, streamId),
  };
};

const mapDispatchToProps = (dispatch, { streamId }) => {
  return {
    startPreviewing: () => dispatch(startViewerCameraPreview({ streamId })),
    invalidatePreview: () =>
      dispatch(invalidateViewerCameraPreview({ streamId })),
    startPublishing: () => dispatch(publishViewerCamera({ streamId })),
    // Off-panel buttons retry capture directly (the tap is already a user
    // gesture); a denied retry surfaces the permission asker.
    retryPreviewing: () =>
      dispatch(
        startViewerCamera({ streamId, trigger: PREVIEW_TRIGGER.OFF_PANEL })
      ),
    stopPublishing: () => dispatch(stopViewerCamera({ streamId })),
    setAudioEnabled: isEnabled =>
      dispatch(
        setViewerCameraTrackEnabled({
          streamId,
          trackType: LOCAL_TRACK_TYPE.AUDIO,
          isEnabled,
        })
      ),
    setVideoEnabled: isEnabled =>
      dispatch(
        setViewerCameraTrackEnabled({
          streamId,
          trackType: LOCAL_TRACK_TYPE.VIDEO,
          isEnabled,
        })
      ),
    openMoreMenu: () => dispatch(openViewerCameraMoreModal()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LivestreamViewerCamera);
